var _path, _path2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.62268e-07 17C-1.17422e-07 20.3137 2.68629 23 6 23L17 23C20.3137 23 23 20.3137 23 17L23 11.2454C21.6304 12.3433 19.8919 13 18 13C13.5817 13 10 9.41828 10 5C10 3.10811 10.6567 1.3696 11.7546 -5.13811e-07L6 -2.62268e-07C2.68629 -1.17422e-07 -8.8794e-07 2.68629 -7.43093e-07 6L-2.62268e-07 17Z",
    fill: "#AF51C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.62268e-07 17C-1.17422e-07 20.3137 2.68629 23 6 23L17 23C20.3137 23 23 20.3137 23 17L23 11.2454C21.6304 12.3433 19.8919 13 18 13C13.5817 13 10 9.41828 10 5C10 3.10811 10.6567 1.3696 11.7546 -5.13811e-07L6 -2.62268e-07C2.68629 -1.17422e-07 -8.8794e-07 2.68629 -7.43093e-07 6L-2.62268e-07 17Z",
    fill: "url(#paint0_linear_1_4)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 4,
    transform: "rotate(-90 18 5)",
    fill: "#AF51C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4",
    x1: -10,
    y1: 15.5,
    x2: 35.8187,
    y2: 4.7287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F79CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF51C5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b620b8819d8d4fe15cf2550bb0e2fccb.svg";
export { ForwardRef as ReactComponent };